import { HighlightOffOutlined } from '@mui/icons-material';
import React, { ReactNode } from 'react';
import './ModalBox.css';
import { Modal } from 'reactstrap';

export interface IModalBoxProps {
    heading?: ReactNode,
    subHeading?: ReactNode,
    options?: string[];
    defaultOption?: string;
    body: ReactNode;
    icon?: any,
    canClose?: () => boolean,
    setResult?: (value: string) => void,
    className?: string
}

export const ModalBox = (props: IModalBoxProps) => {
    const onClickOutside = (e: React.MouseEvent<HTMLTableCellElement, MouseEvent>) => {
        if (props.setResult) {
            e.stopPropagation();

            if (!props.canClose || props.canClose()) {
                if (e.target === e.currentTarget) {
                    props.setResult("ClickOutsideModal");
                }
            }
        }
    };

    const close = () => {
        if (props.setResult) {
            if (props.canClose && props.canClose()) {
                props.setResult("CloseModal");
            }
        }
    };

    const Icon = props.icon;

    return (
        <>
            {props.body &&
                <Modal isOpen={true} className={"modal-box " + props.className}>
                    <div className="modal-container">
                        <div className="modal-icon">
                            {Icon &&
                                <Icon />
                            }
                        </div>

                        {props.heading && <>
                            <div className="modal-heading">{props.heading}</div>

                            <div className="modal-close-button" onClick={close}>
                                <HighlightOffOutlined />
                            </div>

                            {props.subHeading &&
                                <div className="modal-sub-heading">{props.subHeading}</div>
                            }

                            <div className="modal-body">
                                {props.body}
                            </div>
                        </>}

                        {!props.heading && props.body}

                        <div className="modal-button-container">
                            {
                                props.options?.map(opt => {
                                    return (<button key={opt} className={(opt === props.defaultOption ? "primary " : "") + "modal-button"} onClick={() => { if (props.setResult) props.setResult(opt); }}>{opt}</button>);
                                })
                            }
                        </div>
                    </div>
                </Modal>
            }
        </>
    );
};